/* oneOone Venice theme — interactions */

// Scroll-triggered reveals
(function() {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.reveal, .reveal-stagger').forEach(function(el){ el.classList.add('in'); });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.reveal, .reveal-stagger').forEach(function(el){ io.observe(el); });
})();

// Subtle parallax on hero image
(function() {
  var heroImg = document.querySelector('.hero-image img, .hero-image .hero-svg');
  if (!heroImg) return;
  var raf = null;
  window.addEventListener('scroll', function(){
    if (raf) return;
    raf = requestAnimationFrame(function(){
      var y = window.scrollY;
      if (y < window.innerHeight) {
        heroImg.style.transform = 'translateY(' + (y * 0.15) + 'px) scale(' + (1 + y * 0.00012) + ')';
      }
      raf = null;
    });
  }, { passive: true });
})();

// Header auto-hide on scroll down
(function() {
  var header = document.querySelector('[data-header]');
  if (!header) return;
  var last = 0;
  window.addEventListener('scroll', function(){
    var y = window.scrollY;
    if (y > 80 && y > last) {
      header.style.transform = 'translateY(-100%)';
    } else {
      header.style.transform = 'translateY(0)';
    }
    last = y;
  }, { passive: true });
})();

// Cart drawer
(function() {
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  var toggleButtons = document.querySelectorAll('[data-cart-toggle]');
  var closeBtn = document.querySelector('[data-cart-close]');

  if (!drawer || !overlay) return;

  function open(e) {
    if (e) e.preventDefault();
    drawer.classList.add('open');
    overlay.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  toggleButtons.forEach(function(btn){ btn.addEventListener('click', open); });
  if (closeBtn) closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
})();

// Update cart count after add-to-cart (fetch refresh)
function updateCartCount() {
  fetch(window.theme.cartUrl + '.js')
    .then(function(r){ return r.json(); })
    .then(function(cart){
      document.querySelectorAll('[data-cart-count]').forEach(function(el){
        el.textContent = cart.item_count;
      });
    });
}

// Add-to-cart form handler
(function() {
  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var formData = new FormData(form);
    fetch(window.theme.cartAddUrl + '.js', { method: 'POST', body: formData })
      .then(function(r){ return r.json(); })
      .then(function(){ updateCartCount(); refreshCartDrawer(); })
      .catch(function(err){ console.error(err); });
  });
})();

function refreshCartDrawer() {
  fetch(window.location.pathname + '?section_id=cart-drawer-section')
    .catch(function(){});
  // Simple approach: reopen drawer after add. For a fully dynamic drawer,
  // replace HTML via section rendering API.
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  if (drawer && overlay) {
    drawer.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  // Reload page-based cart for simple sync
  setTimeout(function(){ window.location.reload(); }, 800);
}

// Product gallery thumbnail switching
(function() {
  var thumbs = document.querySelectorAll('.product-gallery-thumb');
  var main = document.querySelector('.product-gallery-main img');
  if (!main || !thumbs.length) return;
  thumbs.forEach(function(thumb){
    thumb.addEventListener('click', function(){
      var src = thumb.querySelector('img') && thumb.querySelector('img').src;
      var fullSrc = thumb.getAttribute('data-full') || src;
      if (fullSrc) main.src = fullSrc;
      thumbs.forEach(function(t){ t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });
})();

// Variant selector — update price and update form input
(function() {
  var variantInput = document.querySelector('[data-variant-id]');
  if (!variantInput) return;
  var options = document.querySelectorAll('.product-option-value');
  var variantsData = window.productVariants || [];
  var selected = {};

  // Initialize from first available variant
  if (variantsData.length) {
    variantsData[0].options.forEach(function(opt, i){
      selected['option' + (i+1)] = opt;
    });
  }

  function findVariant() {
    return variantsData.find(function(v){
      return v.options.every(function(opt, i){
        return opt === selected['option' + (i+1)];
      });
    });
  }

  function update() {
    var v = findVariant();
    if (!v) return;
    variantInput.value = v.id;
    var priceEl = document.querySelector('[data-product-price]');
    if (priceEl) {
      priceEl.textContent = v.price_formatted || (v.price / 100).toFixed(2);
    }
    var btn = document.querySelector('[data-add-btn]');
    if (btn) {
      if (v.available) {
        btn.disabled = false;
        btn.textContent = 'Add to cart →';
      } else {
        btn.disabled = true;
        btn.textContent = 'Sold out';
      }
    }
  }

  options.forEach(function(btn){
    btn.addEventListener('click', function(){
      var optionName = btn.getAttribute('data-option');
      var optionValue = btn.getAttribute('data-value');
      selected[optionName] = optionValue;
      // Mark selected button
      document.querySelectorAll('[data-option="' + optionName + '"]').forEach(function(b){
        b.classList.remove('selected');
      });
      btn.classList.add('selected');
      update();
    });
  });
})();

// Campaign carousel
(function() {
  document.querySelectorAll('[data-carousel]').forEach(function(carousel){
    var slides = carousel.querySelectorAll('.carousel-slide');
    var dots = carousel.querySelectorAll('.carousel-dot');
    var prevBtn = carousel.querySelector('[data-carousel-prev]');
    var nextBtn = carousel.querySelector('[data-carousel-next]');
    var autoplay = carousel.dataset.autoplay === 'true';
    var interval = parseInt(carousel.dataset.interval) || 6000;
    var current = 0;
    var timer = null;
    var paused = false;

    function go(index) {
      slides[current].classList.remove('active');
      if (dots[current]) dots[current].classList.remove('active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('active');
      if (dots[current]) dots[current].classList.add('active');
    }

    function next() { go(current + 1); }
    function prev() { go(current - 1); }

    function startTimer() {
      if (!autoplay || paused) return;
      clearInterval(timer);
      timer = setInterval(next, interval);
    }
    function stopTimer() { clearInterval(timer); }

    if (prevBtn) prevBtn.addEventListener('click', function(){ prev(); startTimer(); });
    if (nextBtn) nextBtn.addEventListener('click', function(){ next(); startTimer(); });
    dots.forEach(function(d, i){ d.addEventListener('click', function(){ go(i); startTimer(); }); });

    // Pause on hover
    carousel.addEventListener('mouseenter', function(){ paused = true; stopTimer(); });
    carousel.addEventListener('mouseleave', function(){ paused = false; startTimer(); });

    // Swipe on mobile
    var touchStart = 0;
    carousel.addEventListener('touchstart', function(e){ touchStart = e.touches[0].clientX; }, { passive: true });
    carousel.addEventListener('touchend', function(e){
      var dx = e.changedTouches[0].clientX - touchStart;
      if (Math.abs(dx) > 50) { dx < 0 ? next() : prev(); startTimer(); }
    });

    // Pause when off-screen
    if ('IntersectionObserver' in window) {
      var visIo = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting) startTimer();
          else stopTimer();
        });
      }, { threshold: 0.2 });
      visIo.observe(carousel);
    } else {
      startTimer();
    }

    // Respect reduced motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      stopTimer();
    }
  });
})();

// Mobile menu toggle (simple)
(function() {
  var toggle = document.querySelector('[data-menu-toggle]');
  var navLeft = document.querySelector('.nav-left');
  if (!toggle || !navLeft) return;
  toggle.addEventListener('click', function(){
    if (navLeft.style.display === 'flex') {
      navLeft.style.display = '';
    } else {
      navLeft.style.display = 'flex';
      navLeft.style.position = 'absolute';
      navLeft.style.top = '100%';
      navLeft.style.left = '0';
      navLeft.style.right = '0';
      navLeft.style.background = 'var(--bg)';
      navLeft.style.padding = '20px';
      navLeft.style.flexDirection = 'column';
      navLeft.style.alignItems = 'flex-start';
      navLeft.style.gap = '16px';
      navLeft.style.borderBottom = '1px solid var(--line)';
    }
  });
})();
